import React from 'react';
import { Navigate } from 'react-router-dom';
import MarketplaceLayout from './MarketplaceLayout';
import UserProfile from './UserProfile';
import { useAuth } from '../../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

/**
 * Profile Page wrapper component
 * This component wraps the UserProfile component with the MarketplaceLayout
 * and handles authentication checks
 */
const ProfilePage = () => {
  const { currentUser, loading } = useAuth();
  
  if (loading) {
    return (
      <MarketplaceLayout>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="70vh">
          <CircularProgress />
        </Box>
      </MarketplaceLayout>
    );
  }
  
  if (!currentUser) {
    return <Navigate to="/marketplace/auth/signin" replace />;
  }
  
  return (
    <MarketplaceLayout>
      <UserProfile />
    </MarketplaceLayout>
  );
};

export default ProfilePage;
